// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3dfc952","794":"10faf251"}[chunkId] + ".chunk.js";
};